import React, { useState, useEffect } from "react";
import { Box, Container, Grid, Typography } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import { Link } from 'react-router-dom';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import axios from 'axios';
import { useDeadline } from "../../../contexts/DeadlineContext";
const NewVersionAbstractFooter = () => {
    const { offButton, abstractHomeSetup, getAbstractDeadLineStatus } = useDeadline();
    const eventid = localStorage.getItem('eventid')
    // const hsscLogo = `${process.env.PUBLIC_URL}/Abstract/loginBanerImage/hssc.png`;
    // const ssfmLogo = `${process.env.PUBLIC_URL}/Abstract/loginBanerImage/ssfm.png`;
    // const SCFMSLOGO = `${process.env.PUBLIC_URL}/Abstract/loginBanerImage/SCFMS2024-logo.png`;


    const facebookLink = abstractHomeSetup.facebook_link && abstractHomeSetup.facebook_link.startsWith('http')
        ? abstractHomeSetup.facebook_link
        : `https://${abstractHomeSetup.facebook_link || ''}`;

    const InstagramLink = abstractHomeSetup.Instagram_link && abstractHomeSetup.Instagram_link.startsWith('http')
        ? abstractHomeSetup.Instagram_link
        : `https://${abstractHomeSetup.Instagram_link || ''}`;

    const LinkedinLink = abstractHomeSetup.linkedin_link && abstractHomeSetup.linkedin_link.startsWith('http')
        ? abstractHomeSetup.linkedin_link
        : `https://${abstractHomeSetup.linkedin_link || ''}`;

    const twitterLink = abstractHomeSetup.twitter_link && abstractHomeSetup.twitter_link.startsWith('http')
        ? abstractHomeSetup.twitter_link
        : `https://${abstractHomeSetup.twitter_link || ''}`;




    let sponsorLogos = [];

    // Parse abstractSponserLogos if it's a JSON string
    if (abstractHomeSetup.abstractSponserLogos && typeof abstractHomeSetup.abstractSponserLogos === 'string' && abstractHomeSetup.abstractSponserLogos.trim() !== '') {
        try {
            sponsorLogos = JSON.parse(abstractHomeSetup.abstractSponserLogos);
        } catch (e) {
            console.error("Error parsing abstractSponserLogos:", e);
            sponsorLogos = [];
        }
    }

    const Footerbackground = 'linear-gradient(90deg, rgba(20, 65, 102, 1) 0%, rgba(20, 66, 103, 1) 36%, rgba(7, 25, 39, 1) 100%)';
    return (

        <Box

            sx={{
                width: '100%',
                background: abstractHomeSetup.color_code
                    ? abstractHomeSetup.color_code
                    : Footerbackground,
                paddingTop: '1rem',
                paddingBottom: '1rem',
                color: 'white',
                backgroundImage: `url(${abstractHomeSetup.abstractFooterImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            }}>
            <Container maxWidth="lg" sx={{ marginTop: '80px' }}>
                <Grid container spacing={2} justifyContent="center">

                    <Grid item xs={12} lg={12} sx={{
                        background: abstractHomeSetup.color_code_three
                            ? abstractHomeSetup.color_code_three
                            : '#274A72',
                        marginTop: { xs: '20px', sm: '30px', md: '40px' },
                        borderRadius: { xs: '0px', sm: '5px', md: '10px' },
                        padding: { xs: '10px', sm: '15px', md: '20px' },
                        ml: { xs: 2, md: 0 },
                    }}>
                        <Grid container spacing={2} alignItems="center">
                            {/* First Box */}
                            <Grid item xs={12} sm={4} lg={4}>
                                <Grid container alignItems="center" spacing={1} justifyContent="flex-start">
                                    <Grid item>
                                        <LocationOnIcon fontSize="large" />
                                    </Grid>
                                    <Grid item>
                                        <Typography variant="body1" color="white">
                                            Event Place
                                        </Typography>
                                        <Typography variant="body2" color="white">
                                            {abstractHomeSetup.event_place || ""}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>

                            {/* Second Box */}
                            <Grid item xs={12} sm={4} lg={4}>
                                <Grid container alignItems="center" spacing={1} justifyContent="flex-start">
                                    <Grid item>
                                        <EmailIcon fontSize="large" />
                                    </Grid>
                                    <Grid item>
                                        <Typography variant="body1" color="white">
                                            Send Email
                                        </Typography>
                                        <Typography variant="body2" color="white">
                                            {abstractHomeSetup.send_email || ""}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>

                            {/* Third Box */}
                            <Grid item xs={12} sm={4} lg={4}>
                                <Grid container alignItems="center" spacing={1} justifyContent="flex-start">
                                    <Grid item>
                                        <PhoneIcon fontSize="large" />
                                    </Grid>
                                    <Grid item>
                                        <Typography variant="body1" color="white">
                                            Call Emergency
                                        </Typography>
                                        <Typography variant="body2" color="white">
                                            {abstractHomeSetup.call_emergency || ""}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} lg={12}>
                        <Grid container spacing={2} alignItems="center" justifyContent="center">
                            <Grid item xs={12} sm={12} lg={12}>
                                <Typography
                                    variant="body1"
                                    color="white"
                                    sx={{
                                        lineHeight: 1.5,
                                        textAlign: 'center',
                                        fontSize: { xs: '1rem', sm: '1.25rem', lg: '1.25rem' }
                                    }}
                                >
                                    For any technical support kindly whatsapp no:{" "}
                                    <a
                                        href="https://wa.me/966565612058"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: 'white', textDecoration: 'none' }}
                                    >
                                        +966 56 561 2058
                                    </a>
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>


                    <Grid item xs={12} lg={12}>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} sm={4} lg={4}>

                                <Grid item>
                                    {/* {
                                        abstractHomeSetup.eventLogo == undefined || "" ?
                                            <span>No Logo Uploaded</span> :
                                            <><img src={abstractHomeSetup.eventLogo} sx={{
                                                width: { xs: '150px', sm: '50px', md: '200px' }, // Responsive width
                                                height: { xs: '75px', sm: '87.5px', md: '100px' }, // Responsive height
                                                borderRadius: '50%',
                                            }} />
                                            </>
                                    } */}
                                    {abstractHomeSetup?.eventLogo ? (
                                        <Box
                                            component="img"
                                            src={`${abstractHomeSetup?.eventLogo}`}
                                            sx={{
                                                width: { xs: '80px', sm: '100px', md: '150px' }, // Adjusted responsive width
                                                height: 'auto', // Maintain aspect ratio
                                                borderRadius: '50%',
                                                mx: 'auto',
                                            }}
                                        />
                                    ) : (
                                        <span>No Logo Uploaded</span>
                                    )}

                                    {/* <img src={`${abstractHomeSetup.base_url}/homepage/${abstractHomeSetup.eventLogo}`} alt="Logo" style={{ width: '200px', height: '100px', }} /> */}
                                </Grid>
                                {/* <Grid item >
                                    <Typography variant="p" color="white" sx={{ lineHeight: 1.5 }}>
                                        Advancements in Forensic Science:<br />
                                        UNVEILING THE FUTURE
                                    </Typography>
                                </Grid> */}

                            </Grid>
                        </Grid>
                    </Grid>


                    <Grid item xs={12} lg={12}>
                        <Grid container spacing={2} alignItems="center">
                            {/* Social Media Icons */}
                            <Grid item xs={12} sm={4} lg={6}>
                                <Grid container alignItems="center" spacing={2}>
                                    {facebookLink && abstractHomeSetup.facebook_link && (
                                        <>
                                            <Grid item>
                                                <a href={facebookLink} target="_blank" rel="noopener noreferrer">
                                                    <FacebookIcon fontSize="large" style={{ color: 'white' }} />
                                                </a>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant="body2" color="white">|</Typography>
                                            </Grid>
                                        </>
                                    )}

                                    {InstagramLink && abstractHomeSetup.Instagram_link && (
                                        <>
                                            <Grid item>
                                                <a href={InstagramLink} target="_blank" rel="noopener noreferrer">
                                                    <InstagramIcon fontSize="large" style={{ color: 'white' }} />
                                                </a>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant="body2" color="white">|</Typography>
                                            </Grid>
                                        </>
                                    )}

                                    {LinkedinLink && abstractHomeSetup.linkedin_link && (
                                        <>
                                            <Grid item>
                                                <a href={LinkedinLink} target="_blank" rel="noopener noreferrer">
                                                    <LinkedInIcon fontSize="large" style={{ color: 'white' }} />
                                                </a>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant="body2" color="white">|</Typography>
                                            </Grid>
                                        </>
                                    )}

                                    {twitterLink && abstractHomeSetup.twitter_link && (
                                        <Grid item>
                                            <a href={twitterLink} target="_blank" rel="noopener noreferrer">
                                                <TwitterIcon fontSize="large" style={{ color: 'white' }} />
                                            </a>
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>


                            {/* <Grid item xs={12} sm={4} lg={6}>
                            <Grid container alignItems="center" spacing={2}>
                                <Grid item>
                                    <a href={facebookLink} target="_blank" rel="noopener noreferrer">
                                        <FacebookIcon fontSize="large" style={{ color: 'white' }} />
                                    </a>
                                </Grid>
                                <Grid item>
                                    <Typography variant="body2" color="white">
                                        |
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <a href={InstagramLink} target="_blank" rel="noopener noreferrer">
                                        <InstagramIcon fontSize="large" style={{ color: 'white' }} />
                                    </a>
                                </Grid>
                                <Grid item>
                                    <Typography variant="body2" color="white">
                                        |
                                    </Typography>
                                </Grid>
                                <Grid item>

                                    <a href={LinkedinLink} target="_blank" rel="noopener noreferrer">
                                        <LinkedInIcon fontSize="large" style={{ color: 'white' }} />
                                    </a>
                                </Grid>
                                <Grid item>
                                    <Typography variant="body2" color="white">
                                        |
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <a href={twitterLink} target="_blank" rel="noopener noreferrer">
                                        <TwitterIcon fontSize="large" style={{ color: 'white' }} />
                                    </a>


                                </Grid>
                            </Grid>
                        </Grid> */}


                            {/* Additional Logos */}
                            <Grid item xs={12} sm={4} lg={6}>
                                <Grid container alignItems="center" spacing={2}>
                                    {sponsorLogos.map((logo, index) => (
                                        <Grid item xs={12} md={4} sm={4} key={index}> {/* Takes full width on mobile, half on medium screens */}
                                            <Box
                                                component="img"
                                                src={`${logo}`}
                                                alt={`Sponsor Logo ${index + 1}`}
                                                sx={(theme) => ({
                                                    width: {
                                                        xs: '50%', // 50% width on extra small devices
                                                        sm: '50%', // 50% width on small devices
                                                        md: abstractHomeSetup.sponser_logo_size || '100%', // Custom size or 100% on medium and larger devices
                                                    },
                                                    height: 'auto', // Maintain aspect ratio
                                                    marginLeft: {
                                                        xs: 'auto', // Align to the right on extra small devices
                                                        sm: 'auto', // Align to the right on small devices
                                                        md: 0, // No margin on medium and larger devices
                                                    },
                                                    display: 'block',
                                                })}
                                            />
                                        </Grid>
                                    ))}

                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>



                    <Grid item xs={12} lg={12} marginTop="20px">
                        <hr style={{ borderColor: 'white', width: '100%' }} />
                    </Grid>
                    {/* Second Row */}
                    <Grid item xs={12} container justifyContent="center" >
                        <Typography color="white" variant="subtitle1">
                            {`© ${new Date().getFullYear()} , ${abstractHomeSetup?.event_name} - All Rights Reserved`}
                        </Typography>
                    </Grid>

                    {/* Third Row (example of additional row) */}


                </Grid>
            </Container>
        </Box >
    );
};


export default NewVersionAbstractFooter;

